import { useState, useEffect, useMemo } from "react";

export function useShopStatus() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  return useMemo(() => {
    const eastern = new Date(now.toLocaleString("en-US", { timeZone: "America/Detroit" }));
    const _day = eastern.getDay();
    const hour = eastern.getHours();
    const min = eastern.getMinutes();

    const openHour = 12;
    const closeHour = 18;
    const isOpen = hour >= openHour && hour < closeHour;

    if (isOpen) {
      const minsLeft = (closeHour - hour - 1) * 60 + (60 - min);
      if (minsLeft <= 60) {
        return { isOpen: true, label: `Open — closes in ${minsLeft} min` };
      }
      const hrs = Math.floor(minsLeft / 60);
      const rm = minsLeft % 60;
      return { isOpen: true, label: rm > 0 ? `Open — closes in ${hrs}h ${rm}m` : `Open — closes in ${hrs}h` };
    }

    if (hour < openHour) {
      const minsUntil = (openHour - hour - 1) * 60 + (60 - min);
      if (minsUntil <= 60) {
        return { isOpen: false, label: `Closed — opens in ${minsUntil} min` };
      }
      const hrs = Math.floor(minsUntil / 60);
      return { isOpen: false, label: `Closed — opens in ${hrs}h` };
    }

    return { isOpen: false, label: "Closed — opens tomorrow at 12 p.m." };
  }, [now]);
}
